export interface PhoneMask {
    mask: string
    lengths: number[]
}

export const PHONE_MASKS: readonly PhoneMask[] = [
    {
        mask: '1#########',
        lengths: [9, 10],
    },
    {
        mask: '01#########',
        lengths: [10, 11],
    },
    {
        mask: '2#########',
        lengths: [10],
    },
    {
        mask: '02#########',
        lengths: [11],
    },
    {
        mask: '3#########',
        lengths: [10],
    },
    {
        mask: '03#########',
        lengths: [11],
    },
    {
        mask: '500######',
        lengths: [9],
    },
    {
        mask: '0500######',
        lengths: [11],
    },
    {
        mask: '5#########',
        lengths: [10],
    },
    {
        mask: '05#########',
        lengths: [11],
    },
    {
        mask: '7#########',
        lengths: [10],
    },
    {
        mask: '07#########',
        lengths: [11],
    },
    {
        mask: '800#######',
        lengths: [7, 9, 10],
    },
    {
        mask: '0800#######',
        lengths: [8, 10, 11],
    },
    {
        mask: '845#######',
        lengths: [7, 10],
    },
    {
        mask: '0845#######',
        lengths: [8, 11],
    },
    {
        mask: '8#########',
        lengths: [10],
    },
    {
        mask: '08#########',
        lengths: [11],
    },
    {
        mask: '9#########',
        lengths: [10],
    },
    {
        mask: '09#########',
        lengths: [11],
    },
] as const

export function dynamicPhoneMask(val: string | null): string[] {
    const value = val

    const defaultMask = '###########'

    if (!value) return [defaultMask]

    const matchedMask = PHONE_MASKS.find(mask => value.startsWith(getPhoneNumberStartDigits(mask.mask)))

    if (!matchedMask) return [defaultMask]

    const mask = matchedMask.mask
    // Make a copy of the mask replacing the digits,
    // to ensure not deleting the prefix
    const defaultMatchedMask = mask.replace(/\d/g, '#')

    return [mask, defaultMatchedMask]
}

export function getPhoneNumberStartDigits(mask: string): string {
    return mask.replaceAll('#', '')
}
